export default __webpack_public_path__ + "static/media/CNo.45-3.135cbf21.jpg";